import { Col, Form, Row, Typography } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { useMemo } from "react";
import { useQuery } from "react-query";
import { getDefaultOptions } from "../../../../apis/DefaultOption";
import RequiredStar from "../../../atoms/RequiredStar";
import { CustomAlert } from "../../Alert";
import { CustomForm, FormLabel } from "../../Form/index.styled";
import { CautionIcon } from "../../Icon";
import { UserInfoServiceAirconFilterForm } from "./AirconFilter";
import { UserInfoServiceBatteryForm } from "./Battery";
import { UserInfoServiceBrakePadForm } from "./BrakePad";
import { UserInfoServiceEngineOilForm } from "./EngineOil";
import { CheckableTagForm } from "./Form/CheckableTag";
import { UserInfoServiceTireForm } from "./Tire";
import { UserInfoServiceTireSizeForm } from "./TireSize";
import { UserInfoServiceWheelAlignmentForm } from "./WheelAlignment";

interface UserInfoServiceFormProps {
  form: FormInstance<any>;
  readonly?: boolean;
  consignmentServicesReadonly?: boolean;
}
/**
 *
 * @param param0 정비가능 항목
 * @returns
 */
export const UserInfoServiceForm: React.FC<UserInfoServiceFormProps> = ({
  form,
  readonly = false,
  consignmentServicesReadonly = false,
}) => {
  const { data } = useQuery("DefaultOption", getDefaultOptions, {
    refetchOnMount: "always",
  });

  const minInch = useMemo(
    () => +(data?.find((item) => item.key === "minInch")?.value || 12),
    [data]
  );
  const maxInch = useMemo(
    () => +(data?.find((item) => item.key === "maxInch")?.value || 23),
    [data]
  );

  return (
    <Row gutter={[0, 48]}>
      <Col span={24}>
        <CustomAlert
          type="info"
          showIcon
          icon={<CautionIcon width={16} height={16} />}
          inline
          message="입력해주신 정보를 바탕으로 실제 예약이 잡혀요. 실제 정비 가능한 항목만 체크해주세요."
        />
        <Form.Item hidden name={["repairShopOption", "id"]} />
        <Form.Item
          hidden
          name={["repairShopOption", "options", "isNextDayDelivery"]}
        />
      </Col>
      <Col span={24}>
        <Row gutter={[0, 12]}>
          <Col span={24}>
            <FormLabel>
              타이어 교체
              <RequiredStar />
            </FormLabel>
          </Col>
          <Col span={24}>
            <UserInfoServiceTireForm form={form} readonly={readonly} />
          </Col>
          <CustomForm.Item noStyle shouldUpdate>
            {({ getFieldValue }) =>
              getFieldValue([
                "repairShopOption",
                "options",
                "services",
                "tire",
                "isActivated",
              ]) && (
                <>
                  <Col span={24}>
                    <Typography.Title level={5} style={{ marginTop: 24 }}>
                      사이즈 ({minInch}-{maxInch}인치)
                    </Typography.Title>
                  </Col>
                  <Col span={24}>
                    <UserInfoServiceTireSizeForm
                      form={form}
                      readonly={readonly}
                    />
                  </Col>
                  {/* <Col span={24}>
                    <Typography.Title level={5} style={{ marginTop: 24 }}>
                      배송옵션
                    </Typography.Title>
                  </Col>
                  <Col span={24}>
                    <CustomForm.Item
                      name={[
                        "repairShopOption",
                        "options",
                        "isNextDayDelivery",
                      ]}
                    >
                      <CheckableTagForm
                        checked={form.getFieldValue([
                          "repairShopOption",
                          "options",
                          "isNextDayDelivery",
                        ])}
                        readonly={readonly}
                      >
                        내일장착
                      </CheckableTagForm>
                    </CustomForm.Item>
                  </Col> */}
                </>
              )
            }
          </CustomForm.Item>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[0, 12]}>
          <Col span={24}>
            <FormLabel>
              배터리 교체
              <RequiredStar />
            </FormLabel>
          </Col>
          <Col span={24}>
            <UserInfoServiceBatteryForm form={form} readonly={readonly} />
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[0, 12]}>
          <Col span={24}>
            <FormLabel>
              엔진오일 교체
              <RequiredStar />
            </FormLabel>
          </Col>
          <Col span={24}>
            {consignmentServicesReadonly && (
              <CustomAlert
                type="info"
                showIcon
                icon={<CautionIcon width={16} height={16} />}
                inline
                message="엔진오일 교체 및 브레이크패드는 위탁판매 서비스로 타이어픽에서 설정해요. 서비스 이용 및 설정 변경은 고객센터로 문의해주세요."
                style={{ marginBottom: 12 }}
              />
            )}
            <UserInfoServiceEngineOilForm
              form={form}
              readonly={readonly || consignmentServicesReadonly}
            />
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[0, 12]}>
          <Col span={24}>
            <FormLabel>
              브레이크패드
              <RequiredStar />
            </FormLabel>
          </Col>
          <Col span={24}>
            <UserInfoServiceBrakePadForm
              form={form}
              readonly={readonly || consignmentServicesReadonly}
            />
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[0, 12]}>
          <Col span={24}>
            <FormLabel>
              휠얼라인먼트
              <RequiredStar />
            </FormLabel>
          </Col>
          <Col span={24}>
            <UserInfoServiceWheelAlignmentForm
              form={form}
              readonly={readonly}
            />
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[0, 12]}>
          <Col span={24}>
            <FormLabel>
              에어컨필터
              <RequiredStar />
            </FormLabel>
          </Col>
          <Col span={24}>
            <UserInfoServiceAirconFilterForm form={form} readonly={readonly} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
